import {Component, OnInit} from '@angular/core';
import {CancelledInvoicesService} from '../../../shared/services/cancelled-invoices.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import * as moment from 'moment';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-cancelled-invoices',
  templateUrl: './cancelled-invoices.component.html',
  styleUrls: ['./cancelled-invoices.component.scss']
})

export class StockistCancelledInvoicesComponent implements OnInit {
  submitting = false;
  cancelledInvoices = [];
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public cancelledInvoicesService: CancelledInvoicesService,
              private fb: FormBuilder) {
    this.bsConfig = Object.assign({}, {containerClass: 'theme-dark-blue', dateInputFormat: 'YYYY-MM-DD'}, {showWeekNumbers: false});
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'user_id': [''],
      'invoice_no': [''],
      'total_amount': [''],
      'date': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.cancelledInvoices = [];
    this.cancelledInvoicesService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.cancelledInvoices = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.triggerScroll();
      } else {
        this.cancelledInvoices = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  navigateTo(data) {
    window.open(data.invoice_url, '_blank')
  }

  markInvoice(event) {
    console.log('event', event.target.value);
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'user_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.user_id : '',
      'invoice_no': (this.searchForm && this.searchForm.value) ? this.searchForm.value.invoice_no : '',
      'total_amount': (this.searchForm && this.searchForm.value) ? this.searchForm.value.total_amount : '',
      'date': (this.searchForm && this.searchForm.value) ? moment(this.searchForm.value.date).format('YYYY-MM-DD') : ''
    };
    this.get(params);
  }
}
